import { render, staticRenderFns } from "./ProjectMaterials.vue?vue&type=template&id=5702d8bc&scoped=true&"
import script from "./ProjectMaterials.vue?vue&type=script&lang=js&"
export * from "./ProjectMaterials.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMaterials.vue?vue&type=style&index=0&id=5702d8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5702d8bc",
  null
  
)

export default component.exports